<template>
  <div class="chart-mini-progress">
    <div class="target" :style="{ left: target + '%'}" @click="change=!change">
      <span :style="{ backgroundColor: color }" />
      <span :style="{ backgroundColor: color }" />
    </div>
    <div class="hover-tip" :style="{left: customX, top: customY}" v-show="flag">{{hoverText}}</div>
    <div class="progress-wrapper" :style="{ height: height }" @mouseover="test1" @mouseleave="flag=false">
      <!-- <transition name="bounce"> -->
        <div
          class="progress"
          :class="{'progress-hover': change}"
          :style="{ backgroundColor: color, width: percentage + '%', height: height }"
          @mouseover.stop="test2"
          @mouseleave.stop="flag=false"
        ></div>
      <!-- </transition> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "MiniProgress",
  props: {
    target: {
      type: Number,
      default: 0,
    },
    height: {
      type: String,
      default: "10px",
    },
    color: {
      type: String,
      default: "#13C2C2",
    },
    percentage: {
      type: Number,
      default: 0,
    },
    leftCount: {
      type: Number,
      default: 0,
    },
    rightCount: {
      type: Number,
      default: 0,
    },
    rightPercentage: {
      type: Number,
      default: 0,
    },
    leftHoverText: {
      type: String,
      default: "",
    },
    rightHoverText: {
      type: String,
      default: "",
    },
    showTip: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      change: false,
      flag: false,
      hoverText: "",
      customX: 0,
      customY: 0
    };
  },
  methods: {
    /* computerTipPos(position) {
      return {

      }
    }, */
    test1(e) {
      if(this.showTip == false) return;
      this.hoverText = `${this.rightHoverText}`;
      // let computerRes = this.computerTipPos(e)
      this.customX = e.layerX + 'px';
      this.customY = (e.layerY - 30) + 'px';
      // console.log('x,y', e, this.customX, this.customY)
      this.flag = true;
    },
    test2(e) {
      if(this.showTip == false) return;
      this.hoverText = `${this.leftHoverText}`;
      this.customX = e.layerX + 'px';
      this.customY = (e.layerY - 30) + 'px';
      this.flag = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.bounce-enter, .bounce-leave-to {
  width: 0;
}
.bounce-enter-to, .bounce-leave {
  width: 60px !important;
}
.bounce-enter-active, .bounce-leave-active {
  transition: width 2s ease;
}
.chart-mini-progress {
  padding: 5px 0;
  position: relative;
  width: 100%;

  .target {
    position: absolute;
    top: 0;
    bottom: 0;

    span {
      border-radius: 100px;
      position: absolute;
      top: 0;
      left: 0;
      height: 4px;
      width: 2px;

      &:last-child {
        top: auto;
        bottom: 0;
      }
    }
  }
  .progress-hover {
    // width: 0px !important;
  }
  .progress-wrapper {
    background-color: #f5f5f5;
    position: relative;

    .progress {
      transition: width 1.2s ease;
      border-radius: 1px 0 0 1px;
      background-color: #1890ff;
      width: 0;
      height: 100%;
    }
  }
  .hover-tip {
    position: absolute;
    width: max-content;
    height: 24px;
    transform: translateX(-50%);
    padding: 0 5px;
    line-height: 24px;
    text-align: center;
    font-size: 12px;
    font-family: HelveticaNeue;
    color: rgba(0, 0, 0, 0.65);
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 0px 0px 10px 0px rgba(174, 174, 174, 0.65);
    border-radius: 1px;
    z-index: 1000;
  }
}
</style>
